import React, { useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";

import Hidden from "@material-ui/core/Hidden";
import { useHistory } from "react-router-dom";

import OrdersTab from "../../components/OrdersTabs";
import NotFoundPage from "../NotFoundPage";

export default function Bank() {
  const classes = useStyles();
  let history = useHistory();

  return (
    <div className={classes.container}>
      <Hidden mdUp>
        <OrdersTab />
      </Hidden>

      <Hidden smDown>
        <NotFoundPage />
      </Hidden>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    [theme.breakpoints.down("xs")]: {
      // minWidth: "450px",
      maxWidth: "450px",
    },
  },
}));
